<template>
  <b-container fluid class="select p-5">
    <cLogo />
    <div class="select__header mt-5">
      <h1 class="select__title">Build your RAND boat</h1>
      <p class="select__description">Configure and calculate the price of your favorite RAND Boat</p>
    </div>
    <b-row>
      <b-col class="boat text-center" cols="12" xl="4" md="6 " v-for="product in products" :key="product.id" v-on:click="next(product.name)">
        <div class="boat__test">
          <p class="boat__feet">{{ product.name.split('-')[1] }}</p>
          <img v-if="product.name.split('-')[0] == 'escape'" class="boat__image" src="@/assets/png/Escape.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'leisure'" class="boat__image" src="@/assets/png/Leisure.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'mana'" class="boat__image" src="@/assets/png/Mana.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'play'" class="boat__image" src="@/assets/png/Play.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'source'" class="boat__image" src="@/assets/png/Source.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'spirit'" class="boat__image" src="@/assets/png/Spirit.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'supreme'" class="boat__image" src="@/assets/png/Supreme.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'breeze'" class="boat__image" src="@/assets/png/Breeze.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'roamer'" class="boat__image" src="@/assets/png/Roamer.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'archipelago'" class="boat__image" src="@/assets/png/Archipelago.png" :alt="product.name.split(' ')[0]" />
          <img v-if="product.name.split('-')[0] == 'solara'" class="boat__image" src="@/assets/png/Solara.png" :alt="product.name.split(' ')[0]" />
          <p class="boat__name no-weglot">{{ product.name.split('-')[0] }}</p>
          <p v-if="product.name.split('-')[0] == 'escape'" class="boat__price">From {{ formatToEuro(245900) }}</p>
          <p v-if="product.name.split('-')[0] == 'leisure'" class="boat__price">From {{ formatToEuro(159900) }}</p>
          <p v-if="product.name.split('-')[0] == 'mana'" class="boat__price">From {{ formatToEuro(49900) }}</p>
          <p v-if="product.name.split('-')[0] == 'play'" class="boat__price">From {{ formatToEuro(89900) }}</p>
          <p v-if="product.name.split('-')[0] == 'source'" class="boat__price">From {{ formatToEuro(69900) }}</p>
          <p v-if="product.name.split('-')[0] == 'spirit'" class="boat__price">From {{ formatToEuro(119900) }}</p>
          <p v-if="product.name.split('-')[0] == 'supreme'" class="boat__price">From {{ formatToEuro(145900) }}</p>
          <p v-if="product.name.split('-')[0] == 'breeze'" class="boat__price">From {{ formatToEuro(39900) }}</p>
          <p v-if="product.name.split('-')[0] == 'roamer'" class="boat__price">From {{ formatToEuro(169900) }}</p>
          <p v-if="product.name.split('-')[0] == 'archipelago'" class="boat__price">From {{ formatToEuro(259900) }}</p>
          <p v-if="product.name.split('-')[0] == 'solara'" class="boat__price">From {{ formatToEuro(245900) }}</p>
        </div>
      </b-col>
    </b-row>
    <p class="select__copyright no-weglot">
      Powered by &copy;
      <a class="select__link no-weglot" href="https://www.reepco.dk" target="_blank">REEPCO STUDIO</a>
    </p>
  </b-container>
</template>

<script>
import cLogo from '@/components/cLogo.vue'
import { formatToEuro } from '@/utils'

export default {
  name: 'lSelect',
  components: {
    cLogo,
  },
  methods: {
    formatToEuro,
    next(product) {
      console.log('product', product)
      this.$router.push('/' + product)
    },
  },
  data() {
    return {
      products: [
        {
          name: 'breeze-20',
        },
        {
          name: 'source-22',
        },
        {
          name: 'mana-23',
        },
        {
          name: 'play-24',
        },
        {
          name: 'spirit-25',
        },
        {
          name: 'supreme-27',
        },
        {
          name: 'leisure-28',
        },
        {
          name: 'roamer-29',
        },
        // {
        //   name: 'escape-30',
        // },
        {
          name: 'archipelago-32',
        },
        {
          name: 'solara-33',
        },
      ],
    }
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_utilities';

.select {
  &__header {
  }
  &__title {
    text-align: center;
    letter-spacing: 0.8px;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.2;
  }
  &__description {
    text-align: center;
    font-weight: 300;
    font-size: 14px;
    letter-spacing: 0.8px;
  }
  .row:hover .boat:not(:hover) {
    filter: grayscale(100%);
    opacity: 0.5;
  }
  &__copyright {
    font-size: 10px;
    letter-spacing: 0.8px;
    text-align: right;
    @media only screen and (max-width: $MD) {
      text-align: center;
    }
  }
  &__link {
    font-size: 10px;
    letter-spacing: 0.8px;
    text-decoration: none;
  }
}
.boat {
  position: relative;
  min-height: 175px;
  padding-top: 100px;
  cursor: pointer;
  &:hover .boat__image {
    // transform: translateY(-15px);
    // animation: wiggle 2s infinite;
    animation: up 1.7s infinite;
  }
  &__feet {
    font-size: 133px;
    color: rgba(59, 59, 59, 0.13);
    font-weight: 700;
    letter-spacing: 1.8px;
    position: absolute;
    top: 25px;
    left: 100px;
    z-index: -1;
  }
  &__image {
    width: 100%;

    transition: all 0.2s ease;
  }
  &__name {
    font-weight: 700;
    margin: 0;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    font-size: 18px;
  }
  &__price {
    color: rgba(85, 89, 92, 0.72);
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1.8px;
    text-transform: uppercase;
  }
}
@keyframes wiggle {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(3deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes up {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
